module.exports = __webpack_public_path__ + "static/media/homepage-hero-new.cbcb810c.jpg";